import { Checkbox, SxProps, Theme } from '@mui/material';
import { toSxArray } from 'src/utils/sx';

export interface RowSelectionState {
  isRowSelected: (id: string) => boolean;
  onRowSelectionChange: (id: string, selected: boolean) => void;
}

export const RowSelectCheckbox = ({
  id,
  selectionState,
  sx,
}: {
  id: string;
  selectionState: RowSelectionState;
  sx?: SxProps<Theme>;
}) => {
  const isSelected = selectionState.isRowSelected(id);

  return (
    <Checkbox
      size="small"
      checked={isSelected}
      data-testid={`custom-views-row-select-${id}`}
      onChange={(_e, checked) => selectionState.onRowSelectionChange(id, checked)}
      onClick={(e) => {
        e.stopPropagation();
        (e.target as HTMLElement).blur();
      }}
      sx={[
        {
          padding: '0.25rem',
          opacity: isSelected ? 1 : 0,
          transition: 'opacity 0.15s ease',
        },
        ...toSxArray(sx),
      ]}
    />
  );
};
